import {Browser} from "./Browser";
import {Chronicle} from "./Chronicle";
import {History} from "./History";
import {Slider} from "./Slider";
import {Observer} from "./Observer";
import {Podcastplayer} from "./Podcastplayer";
import {Display} from "./Display";
import {Lightbox} from "./Lightbox";
import {Form} from "./Form";
import {Shop} from "./Shop";

export class Basic
{
    static init()
    {
        Basic.base = '/';
        Basic.lang = 'de';
        Basic.resizeTimer = 0;
        Basic.sculpture = '';
        Basic.scrollTimer = 0;
        Basic.remScrollY = 0;
        Basic.shop = new Shop();
    }

    static do_afterLoad(scrollToTop, scrollToEl, scrollToPosY)
    {
        // perform scroll action
        document.documentElement.style.scrollBehavior = 'auto';
        if(scrollToTop === true)
        {
            document.documentElement.scrollTo(0, 0);
        }
        else if(scrollToEl)
        {
            scrollToEl.scrollIntoView(true);
        }
        else if(scrollToPosY)
        {
            document.documentElement.scrollTo(0, scrollToPosY);
        }
        document.documentElement.style.scrollBehavior = '';

        // prevent menu from poping up
        Basic.remScrollY = 0;

        // set calendar filter height
        Basic.set_filterHeight();

        // close member list on mobile
        if(Display.device !== 'desktop' && document.getElementById('w--member--list'))
        {
            document.getElementById('w--member--list').removeAttribute('open');
        }

        // set no blur for pages with image header
        if(document.body.querySelector('.w__header--full,.w__header--half'))
        {
            document.body.classList.add('mod--no-blur');
        }

        // start header slider
        const headers = document.body.querySelectorAll('.w__header');
        for(let i=0; i<headers.length; i++)
        {
            new Slider(headers[i]);
        }

        // initialize Podcast player
        const podcasts = document.body.querySelectorAll('.w__podcast--container:not(.initialized)');
        for(let i=0; i<podcasts.length; i++)
        {
            podcasts[i].player = new Podcastplayer(podcasts[i]);
        }

        // intersection observer
        if(document.getElementById('w--load-into') &&
           document.getElementById('w--load-into').dataset.autoload)
        {
            new Observer(document.getElementById('w--load-into'));
        }

        // activate section marker
        const markEl = document.body.querySelector('.w__search--filter-marker .w__search--filter.active');
        if(markEl)
        {
            Basic.set_filterMarker(markEl);
        }

        // activate chronicle if present
        Chronicle.initialize();

        // start autolightbox if present
        let autoLightboxEl = document.getElementById('w--auto-lightbox');
        if(autoLightboxEl)
        {
            // get inner element for videos
            if(autoLightboxEl.querySelector('.w__tile--video-image'))
            {
                autoLightboxEl = autoLightboxEl.querySelector('.w__tile--video-image');
            }
            new Lightbox(autoLightboxEl,true);
        }

        // insert googlemap (and api)
        let googlemap = document.body.querySelector('.w__link--googlemap');
        if(googlemap)
        {
            if(document.getElementById('w--googlemap-api'))
            {
                Basic.insert_googlemap(googlemap);
            }
            else
            {
                const myLibrary = document.createElement('script');
                myLibrary.id = 'w--googlemap-api';
                myLibrary.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA_tyEqS7cc5-KTbZYVmMgMvAnJK46kn7w';
                myLibrary.onload = () =>
                {
                    Basic.insert_googlemap(googlemap);
                };
                document.head.appendChild(myLibrary);
            }
        }

        // activate forms
        let forms = document.body.querySelectorAll('.w__form:not(.active)');
        for(let i=0; i<forms.length; i++)
        {
            new Form(forms[i]);
        }

        // insert SOUND ON button if full or half header and sculpture not playing
        if(Basic.sculpture)
        {
            if(Basic.sculpture.playButton)
            {
                Basic.sculpture.playButton.remove();
            }

            const myHeader = document.body.querySelector('.w__header--full,.w__header--half');

            if(!myHeader || Basic.sculpture.audio && Basic.sculpture.audio.isPlaying)
            {
                if(Basic.sculpture.controlButton &&
                  !document.body.querySelector('#w--nav .w__nav--search-container.active'))
                {
                    Basic.sculpture.controlButton.classList.add('active');
                }
            }
            else if(myHeader)
            {
                if(Basic.sculpture.controlButton)
                {
                    Basic.sculpture.controlButton.classList.remove('active');
                    Basic.sculpture.controlButton.classList.remove('mod--on');
                    Basic.sculpture.controls.classList.remove('active');
                }
                Basic.sculpture.add_soundOnButton(myHeader);
            }
        }

        // activate newletter popup under special conditions
        if(!localStorage.getItem('hide-newsletter-form') &&
           document.querySelector('.w__module--calendar,.w__module--news'))
        {
            const el = document.createElement('span');
            el.dataset.action = 'newsletter';
            new Lightbox(el);
        }
    }

    static insert_googlemap(el)
    {
        if(el.dataset.l1 && el.dataset.l2)
        {
            const color = window.getComputedStyle(document.body).getPropertyValue('--color');
            const myMapCanvas = document.createElement('div');
            myMapCanvas.classList.add('w__googlemap');
            el.insertAdjacentElement('afterend', myMapCanvas);

            // noinspection JSUnresolvedVariable,JSUnresolvedFunction
            const latlng = new google.maps.LatLng(el.dataset.l1, el.dataset.l2),
                myOptions = {
                    zoom: 16,
                    center: latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false,
                    navigationControl: false,
                    mapTypeControl: false,
                    zoomControl: true,
                    draggable: true
                },
                map = new google.maps.Map(myMapCanvas, myOptions),
                graustufen = [{featureType: 'all', stylers: [{saturation: -100}, {gamma: 0.90}]},
                              {featureType: 'water', stylers: [{color: color}]}],
                icon = {
                    url: Basic.base + 'pix/em-logo.svg',
                    scaledSize: new google.maps.Size(32, 32), // scaled size
                    origin: new google.maps.Point(0,0), // origin
                    anchor: new google.maps.Point(16,16) // anchor
                },
                marker = new google.maps.Marker({
                    position: latlng,
                    map: map,
                    icon: icon
                });

            // noinspection JSUnresolvedFunction
            map.setOptions({styles: graustufen, disableDefaultUI: true});
            // noinspection JSUnresolvedFunction
            marker.setMap(map);

            el.remove();
        }
    }

    static set_filterMarker(el)
    {
        if(!el)
        {
            el = document.body.querySelector('.w__search--filter-cell .w__search--filter.active');
        }

        if(el)
        {
            const container = el.closest('.w__search--filter-marker'),
                marker = container.querySelector('.w__search--marker'),
                activeEl = container.querySelector('.w__search--filter.active');

            if(activeEl)
            {
                activeEl.classList.remove('active');
            }
            el.classList.add('active');

            marker.style.width = el.getBoundingClientRect()['width'].toString() + 'px';
            marker.style.left = ((el.getBoundingClientRect()['left'] - container.getBoundingClientRect()['left']) * 100 /
                container.getBoundingClientRect()['width']).toString() + '%';
        }
    }

    static set_langMarker(activeEl)
    {
        if(!activeEl)
        {
            activeEl = document.body.querySelector('.w__nav--menu-lang li.active');
        }

        const container = activeEl.closest('.w__nav--menu-lang');
        if(container)
        {
            const marker = container.querySelector('.w__nav--menu-lang-marker');

            marker.style.width = activeEl.getBoundingClientRect()['width'].toString() + 'px';
            marker.style.left = ((activeEl.getBoundingClientRect()['left'] -
                    container.getBoundingClientRect()['left']) * 100 /
                container.getBoundingClientRect()['width']).toString() + '%';
        }
    }

    static set_filterHeight()
    {
        const filters = document.querySelectorAll('.w__calendar--filter-ul');
        for(let i=0; i<filters.length; i++)
        {
            filters[i].classList.add('max-height');
            const maxHeight = filters[i].getBoundingClientRect()['height'];
            filters[i].classList.remove('max-height');
            document.documentElement.style.setProperty(
                '--calendar-filter-' + filters[i].dataset.filterNo,
                maxHeight.toString() + 'px');
        }
    }

    static process_resize()
    {
        Display.analyze();
        Basic.set_filterMarker();
        Basic.set_filterHeight();
        Basic.set_langMarker();
    }

    static process_scroll()
    {
        const scrollY = window.scrollY;
        if(scrollY > Basic.remScrollY)
        {
            Basic.remScrollY = scrollY;
            document.getElementById('w--nav').classList.remove('fixed');
        }
        else if(scrollY < Basic.remScrollY - 200)
        {
            Basic.remScrollY = scrollY;
            document.getElementById('w--nav').classList.add('fixed');
        }

        if(Basic.sculpture)
        {
            Basic.sculpture.process_scroll(scrollY);
        }
    }

    static scroll_toTop()
    {
        document.documentElement.style.scrollBehavior = 'auto';
        document.documentElement.scrollTo(0,0);
        document.documentElement.style.scrollBehavior = '';
    }

    static update_languageMenus(r)
    {
        if(r['originalUrl'] && r['switchUrl'])
        {
            const items = document.body.querySelectorAll('.w__nav--menu-lang a, .w__footer--menu-lang a');
            for(let i = 0; i < items.length; i++)
            {
                items[i].href = (items[i].textContent === Basic.lang) ? r['originalUrl'] : r['switchUrl'];
            }
        }
    }

    static update_page(r, url, loadInto, searchTerm)
    {
        // push new url to history
        if(url)
        {
            History.push_url(url, loadInto, searchTerm);
        }

        // update links
        Basic.update_languageMenus(r);

        // scroll action
        let scrollToTop = !loadInto;

        // get navigation element
        const nav = document.getElementById('w--nav');

        // close open navigation and change tooltip
        if(nav.classList.contains('active'))
        {
            const navButton = document.getElementById('w--nav-button');
            nav.classList.remove('active');
            const rem = navButton.title;
            navButton.title = navButton.dataset.toggleText;
            navButton.dataset.toggleText = rem;
        }

        // remove active menu marker
        const activeLi = nav.querySelector('.w__nav--full li.active');
        if(activeLi)
        {
            activeLi.classList.remove('active');
        }

        // set active menu marker
        const activeA = nav.querySelector('.w__nav--full a[href="' + r['path'] + '"]');
        if(activeA && activeA.closest('li'))
        {
            activeA.closest('li').classList.add('active');
        }

        // remove existing header
        if(!loadInto &&
            document.getElementById('w--header'))
        {
            document.getElementById('w--header').remove();
        }

        // add header if set
        if(r['header'])
        {
            document.getElementById('w--nav').insertAdjacentHTML('afterend', r['header']);
        }

        // get main element
        const moduleContainer = document.getElementById('w--main');

        // load into elements
        if(loadInto === true)
        {
            if(r['calendar'])
            {
                const calendar = moduleContainer.querySelector('.w__calendar--table');
                if(calendar)
                {
                    scrollToTop = false;
                    calendar.insertAdjacentHTML('afterend', r['calendar']);
                    calendar.remove();
                }
            }

            if(r['year-selection'])
            {
                const yearSelection = moduleContainer.querySelector('.w__search--selection-cell');
                if(yearSelection)
                {
                    scrollToTop = false;
                    yearSelection.insertAdjacentHTML('afterend', r['year-selection']);
                    yearSelection.remove();
                }
            }

            if(document.getElementById('w--load-into'))
            {
                if(r['modules'])
                {
                    document.getElementById('w--load-into').innerHTML = r['modules']
                }

                if(r['load-into'])
                {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = r['load-into'];
                    document.getElementById('w--load-into').innerHTML = tempDiv.innerHTML;
                    document.getElementById('w--load-into').style.opacity = '1';
                }
                if(r['load-into-replace'])
                {
                    document.getElementById('w--load-into').remove();
                    document.getElementById('w--main')
                            .insertAdjacentHTML('beforeend',r['load-into-replace']);
                }
            }
        }
        else
        {
            // replace content
            if(moduleContainer)
            {
                moduleContainer.innerHTML = r['modules']
            }
        }

        // update page title
        if(r['page_title'])
        {
            document.title = r['page_title'];
        }

        // replace body class
        document.body.className = r['body-class'];
        if(Browser.mobile === true)
        {
            document.body.classList.remove('w__hover');
            document.body.classList.add('w__mobile');
        }

        // decide on scroll action
        const scrollToEl = document.location.hash ? document.querySelector(document.location.hash) : '',
            scrollToPosY = r['scrollY'] ? r['scrollY'] : 0;
        if((scrollToEl || scrollToPosY))
        {
            scrollToTop = false;
        }

        // start interactivity
        Basic.do_afterLoad(scrollToTop, scrollToEl, scrollToPosY);
    }
}

